import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Home from '../views/Login.vue'
import store from '@/store'

const INIT = store.dispatch('getToken')

const routes = [
  {
    path: '/',
    name: 'Home',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged === true) {
          next('/events')

        } else {
          next()
        }

      })
    },
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged === true) {
          next('/events')

        } else {
          next()
        }

      })
    },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/recoverPassword/:id',
    name: 'RecoverPassword',
    component: () => import('../views/RecoverPassword.vue')
  },
  {
    path: '/register',
    name: 'Register',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged === true) {
          next('/events')

        } else {
          next()
        }

      })
    },
    component: () => import('../views/Register.vue')
  },

  {
    path: '/events',
    name: 'Events',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true) {
          next('/login')
        } else {
          next()
        }

      })
    },
    component: () => import('../views/Events.vue')
  },
  {
    path: '/event/add',
    name: 'Event_add',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/Event_add.vue')
  },
  {
    path: '/event/edit/:id',
    name: 'Event_edit',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/Event_edit.vue')
  }, {
    path: '/event/read/:id',
    name: 'Event_read',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/Event_read.vue')
  }, {
    path: '/account',
    name: 'Account',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/Account.vue')
  }, {
    path: '/activities',
    name: 'Activities',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true || store.state.editor !== 1) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/Activities.vue')
  },
  {
    path: '/equipments',
    name: 'Equipments',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true || store.state.usertype !== 2) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/Equipments.vue')
  }, {
    path: '/programs',
    name: 'Programs',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true || store.state.usertype !== 2) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/Programs.vue')
  }, {
    path: '/paytest',
    name: 'Pay Test',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true || store.state.usertype !== 2) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/PayTest.vue')
  }, {
    path: '/paysuccess/:type/:id/:receipt',
    name: 'Pay Success',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/PaySuccess.vue')
  }, {
    path: '/payerror',
    name: 'Pay Error',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/PayError.vue')
  }, {
    path: '/contact',
    name: 'Contact',
    beforeEnter: (to, from, next) => {
      INIT.then(function () {
        if (store.state.logged !== true) {
          next('/login')
        } else {
          next()
        }
      })
    },
    component: () => import('../views/Contact.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  // history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
